import { cn } from '@mdvip/shared/lib/utils';
import '@mdvip/shared/lib/uiModality';
import type * as React from 'react';

// Base UI ships no textarea primitive, so this is a plain element — matching the registry, which
// also leaves `textarea` unwrapped. `data-slot="input"` (not `"textarea"`) is deliberate: the
// active-border and keyboard-only focus-ring rules in `tokens.css` are keyed on that slot, and the
// design system's own textarea opts into them the same way.
function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="input"
      className={cn(
        'min-h-24 w-full min-w-0 resize-y rounded-md border border-input bg-card px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-[color-mix(in_oklab,var(--foreground)_8%,var(--background))] disabled:text-muted-foreground aria-invalid:border-2 aria-invalid:border-destructive-foreground aria-invalid:bg-[color-mix(in_oklab,var(--destructive)_14%,var(--card))] md:text-sm dark:bg-input/30',
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
